import { axios } from '../../services/axios';

const jsonHeaders = { headers: { 'Content-Type': 'application/json' } };

/**
 * Updates an SRT trunk's editable fields.
 *
 * Name and channels are the only things the form can change — the region is
 * fixed once a trunk is provisioned — so these are set through the same
 * targeted endpoints every other trunk edit page uses. The whole-object
 * `PUT /trunk` is deliberately avoided: it applies the classic SIP trunk
 * contract and rejects any trunk without an audio codec, which no SRT trunk
 * has or needs.
 *
 * @param {object} params
 * @param {string} params.id
 * @param {string} params.name
 * @param {number} params.channels
 */
export default async function updateSRTTrunk({ id, name, channels }) {
    await axios.post(
        '/trunk/name',
        { trunkId: id, trunkName: name },
        jsonHeaders,
    );
    return await axios.post(
        '/trunk/channels',
        { trunkId: id, channels: parseInt(channels) },
        jsonHeaders,
    );
}
